import Cookies from 'js-cookie';
import { DEVICE_ID_COOKIE } from 'constants/cookies';
import { isDevelopment } from 'utils/environment';
import { getStringFromRequestCookie } from 'utils/cookies';
import { IncomingMessage } from 'http';
import cookie from 'cookie';
import { SET_COOKIE_HEADER_NAME } from 'constants/headers';

const COOKIE_OPTIONS = {
  expires: 365, // 1 year
  secure: !isDevelopment,
  sameSite: 'lax' as const,
};

const SERVER_COOKIE_OPTIONS = {
  httpOnly: false,
  secure: !isDevelopment,
  maxAge: 365 * 24 * 60 * 60, // 1 year (in seconds)
  sameSite: 'lax' as const,
};

export const getOrCreateDeviceId = (request?: IncomingMessage, response?: any): string => {
  let deviceId: string;

  if (typeof window !== 'undefined') {
    // Client-side
    deviceId = Cookies.get(DEVICE_ID_COOKIE);
    if (!deviceId) {
      deviceId = Date.now().toString();
      Cookies.set(DEVICE_ID_COOKIE, deviceId, COOKIE_OPTIONS);
    }
  } else {
    // Server-side
    deviceId = getStringFromRequestCookie(DEVICE_ID_COOKIE, request);
    if (!deviceId) {
      deviceId = Date.now().toString();
      response?.setHeader(
        SET_COOKIE_HEADER_NAME,
        cookie.serialize(DEVICE_ID_COOKIE, deviceId, SERVER_COOKIE_OPTIONS)
      );
    }
  }

  return deviceId;
}; 